import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { fetchAddressThunk } from 'slices/addressBook/thunk';
import { AppDispatch, RootState } from 'store';
import { Currency } from 'types';
import { CampaignGig as CampaignGigInterface } from 'types/campaign/milestones'
import { extractOrigin, formatAmount, generateGoogleMapUrl, getCombinedAddress } from 'utils/helpers'

const CampaignGig: React.FC<{ gig: CampaignGigInterface, onDelete: () => void, onEdit: () => void, currency: Currency, viewOnly?: boolean }> = ({ gig, onDelete, onEdit, currency, viewOnly = false }) => {

    const dispatch: AppDispatch = useDispatch();
    const addressBook = useSelector((state: RootState) => state.addressBook.items);

    useEffect(() => {
        if (gig.properties.address) {
            dispatch(fetchAddressThunk({ addressUUID: gig.properties.address }));
        }
    }, [gig])

    return (
        <div>
            <div className="d-flex gap-3">
                {
                    gig.properties.address ? (
                        <div className="screening-question-icon">
                            <i className="mdi mdi-google-maps"></i>
                        </div>
                    ) : (
                        <div className="bg-image gig-thumbnail bgc-white"
                            style={{ backgroundImage: `url(${gig.thumbnail_url})` }}></div>
                    )
                }


                <div className="d-flex flex-column justify-content-center">
                    <span className='gig-name'>{gig.name}</span>
                    {
                        gig.properties.address ? (
                            <>
                                <span className="gig-description">
                                    {getCombinedAddress(addressBook[gig.properties.address]?.address)}
                                </span>
                                <a className='text-primary' onClick={(e) => e.stopPropagation()} href={generateGoogleMapUrl(addressBook[gig.properties.address]?.address.lat, addressBook[gig.properties.address]?.address.lng, addressBook[gig.properties.address]?.address?.place_id, gig.name)} target='_blank' rel='noreferral'>
                                    <i className="mdi mdi-google-maps"></i> View Map
                                </a>
                            </>

                        ) : (
                            <>
                                {gig.properties.description && <span className='gig-description'> {gig.properties.description ?? '-'}</span>}
                                {gig.properties.permalink && <a className='gig-url' href={gig.properties.permalink ?? '#'} target='_blank' rel='noreferrer'> {extractOrigin(gig.properties.permalink ?? '#')} </a>}
                                {gig.properties?.url && <a className='gig-url' href={gig.properties.url ?? '#'} target='_blank' rel='noreferrer'> {extractOrigin(gig.properties.url ?? '#')} </a>}
                            </>

                        )
                    }
                    {!isNaN(Number(gig.value)) && Number(gig.value) > 0 && <span className='gig-amount'>{formatAmount(gig.value, currency?.code, currency?.symbol, currency?.locale)}</span>}
                </div>
            </div>
            {
                !viewOnly &&
                <div className="d-flex align-items-center justify-content-end gap-3">
                    <button className="unset-all" onClick={onDelete}>
                        <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M16.3006 7.29883L14.5051 17.5115C14.3538 18.3723 13.6062 19 12.7324 19H5.4689C4.59505 19 3.84742 18.3723 3.6961 17.5115L1.90063 7.29883" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M17.2 4.60037H12.1375M1 4.60037H6.0625M6.0625 4.60037V2.80018C6.0625 1.80597 6.86839 1 7.8625 1H10.3375C11.3316 1 12.1375 1.80597 12.1375 2.80018V4.60037M6.0625 4.60037H12.1375" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </button>
                    <button className='unset-all text-primary' onClick={onEdit}>Edit</button>
                </div>
            }
            <div className="divider my-5"></div>
        </div>
    )
}

export default CampaignGig
